var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { SignUpTypes, VOLUNTEER_ERROR, } from '../VolunteerServiceContext';
import { convertToFormData } from '../../util/convert-to-form-data';
import { capitalizeName } from '../../util/capitalize';
const post = (uri, data = {}, headers = {}) => axios({
    method: 'post',
    url: `${uri}`,
    data,
    headers: Object.assign(Object.assign({ 'Content-Type': 'application/x-www-form-urlencoded' }, headers), (data instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : {})),
});
const get = (uri, data = {}, headers = {}) => axios({
    method: 'get',
    url: `${uri}`,
    data,
    headers,
});
export const tryGetAccessToken = () => __awaiter(void 0, void 0, void 0, function* () { return window.gdiHost.getAccessToken(); });
export const getValidAccessToken = () => __awaiter(void 0, void 0, void 0, function* () {
    return tryGetAccessToken().then((r) => {
        if (!(r === null || r === void 0 ? void 0 : r.token) || r.token.length === 0)
            throw new Error('Invalid access token');
        return r;
    });
});
const createAuthorizationHeadersFromToken = ({ token }) => ({
    Authorization: `Bearer ${token}`,
});
const createAuthorizationHeadersFromBase64Secret = (base64Secret) => ({
    Authorization: `${base64Secret}`,
});
export const createRestContext = (uri, appSecret) => ({
    getVolunteer: () => getValidAccessToken()
        .then(createAuthorizationHeadersFromToken)
        .then((headers) => get(`${uri}/employee`, {}, headers))
        .then(({ data }) => {
        var _a;
        return ({
            id: data.national_identity_number,
            firstName: capitalizeName(data.first_name),
            lastName: capitalizeName(data.surname),
            email: data.email,
            phone: data.phone_number,
            status: data.status.slug,
            statusLabel: data.status.name,
            assignments: [...((_a = data === null || data === void 0 ? void 0 : data.assignments) !== null && _a !== void 0 ? _a : [])].map(({ id, title, status: { name, slug } }) => ({
                assignmentId: id,
                title: title,
                status: slug,
                statusLabel: name,
            })),
            newsletter: data.newsletter,
        });
    })
        .catch((err) => {
        var _a, _b, _c;
        if (((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) && ((_c = (_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.code)) {
            if (err.response.status === 404 && err.response.data.code === 'rest_post_invalid_id') {
                let error = new Error("Volunteer doesn't exist");
                error.name = VOLUNTEER_ERROR.VOLUNTEER_DOES_NOT_EXIST;
                throw error;
            }
        }
        throw err;
    }),
    registerVolunteer: (input) => getValidAccessToken()
        .then(createAuthorizationHeadersFromToken)
        .then((headers) => post(`${uri}/employee`, {
        email: input.email,
        phone_number: input.phone,
        newsletter: input.newsletter ? true : null,
    }, headers))
        .then((response) => {
        var _a, _b, _c, _d, _e, _f, _g;
        return ({
            id: (_a = response.data.national_identity_number) !== null && _a !== void 0 ? _a : input.id,
            firstName: capitalizeName((_b = response.data.first_name) !== null && _b !== void 0 ? _b : input.firstName),
            lastName: capitalizeName((_c = response.data.surname) !== null && _c !== void 0 ? _c : input.lastName),
            email: (_d = response.data.email) !== null && _d !== void 0 ? _d : input.email,
            phone: (_e = response.data.phone_number) !== null && _e !== void 0 ? _e : input.phone,
            newsletter: (_f = response.data.newsletter) !== null && _f !== void 0 ? _f : input.newsletter,
            status: (_g = response.data.status.slug) !== null && _g !== void 0 ? _g : 'submitted',
        });
    }),
    registerAssignment: (input) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
        return post(`${uri}/assignment`, convertToFormData({
            title: input.title,
            assignment_eligibility: '[]',
            description: input.description,
            qualifications: (_a = input.qualifications) !== null && _a !== void 0 ? _a : '',
            end_date: (_b = input.endDate) !== null && _b !== void 0 ? _b : '',
            schedule: (_c = input.schedule) !== null && _c !== void 0 ? _c : [input.when, input.where].filter((v) => v && v.length > 0).join('\n\n'),
            benefits: (_d = input.benefits) !== null && _d !== void 0 ? _d : '',
            number_of_available_spots: (_f = (_e = input.totalSpots) === null || _e === void 0 ? void 0 : _e.toString()) !== null && _f !== void 0 ? _f : '',
            signup_methods: [],
            featured_media: ((_g = input === null || input === void 0 ? void 0 : input.image) === null || _g === void 0 ? void 0 : _g.item(0)) || null,
            internal_assignment: input.signUp.type === SignUpTypes.Internal ? 'true' : 'false',
            signup_link: input.signUp.type === SignUpTypes.Link ? (_h = input.signUp.link) !== null && _h !== void 0 ? _h : '' : '',
            signup_email: input.signUp.type === SignUpTypes.Contact ? (_k = (_j = input.publicContact) === null || _j === void 0 ? void 0 : _j.email) !== null && _k !== void 0 ? _k : '' : '',
            signup_phone: input.signUp.phone === SignUpTypes.Contact ? (_m = (_l = input.publicContact) === null || _l === void 0 ? void 0 : _l.phone) !== null && _m !== void 0 ? _m : '' : '',
            submitted_by_first_name: input.employer.contacts[0].name,
            submitted_by_email: (_o = input.employer.contacts[0].email) !== null && _o !== void 0 ? _o : '',
            submitted_by_phone: (_p = input.employer.contacts[0].phone) !== null && _p !== void 0 ? _p : '',
            employer_name: input.employer.name,
            employer_website: (_q = input.employer.website) !== null && _q !== void 0 ? _q : '',
            employer_about: (_r = input.employer.about) !== null && _r !== void 0 ? _r : '',
            employer_contacts: input.publicContact
                ? [
                    {
                        name: (_t = (_s = input.publicContact) === null || _s === void 0 ? void 0 : _s.name) !== null && _t !== void 0 ? _t : '',
                        email: (_v = (_u = input.publicContact) === null || _u === void 0 ? void 0 : _u.email) !== null && _v !== void 0 ? _v : '',
                        phone: (_x = (_w = input.publicContact) === null || _w === void 0 ? void 0 : _w.phone) !== null && _x !== void 0 ? _x : '',
                    },
                ]
                : null,
            street_address: (_z = (_y = input.location) === null || _y === void 0 ? void 0 : _y.address) !== null && _z !== void 0 ? _z : '',
            postal_code: (_1 = (_0 = input.location) === null || _0 === void 0 ? void 0 : _0.postal) !== null && _1 !== void 0 ? _1 : '',
            city: (_3 = (_2 = input.location) === null || _2 === void 0 ? void 0 : _2.city) !== null && _3 !== void 0 ? _3 : '',
        }), createAuthorizationHeadersFromBase64Secret(appSecret !== null && appSecret !== void 0 ? appSecret : '')).then((response) => {
            var _a;
            if (response.status !== 200 || !((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.assignment_id)) {
                throw new Error('Something went wrong');
            }
            const toNullString = (key, target) => !target || target === 0 || (typeof target === 'string' && target.length === 0)
                ? { [key]: '-' }
                : {};
            return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, input), { id: response.data.assignment_id }), toNullString('benefits', input === null || input === void 0 ? void 0 : input.benefits)), toNullString('qualifications', input === null || input === void 0 ? void 0 : input.qualifications)), toNullString('readMoreLink', input === null || input === void 0 ? void 0 : input.readMoreLink)), toNullString('totalSpots', input === null || input === void 0 ? void 0 : input.totalSpots)), toNullString('when', input === null || input === void 0 ? void 0 : input.when)), toNullString('where', input === null || input === void 0 ? void 0 : input.where));
        });
    },
    applyToAssignment: (assignmentId) => getValidAccessToken()
        .then(createAuthorizationHeadersFromToken)
        .then((headers) => post(`${uri}/application`, { assignment_id: assignmentId }, headers))
        .then(({ status, statusText }) => {
        if (status !== 200) {
            throw new Error(statusText);
        }
    }),
    getAssignment: (assignmentId) => get(`${uri}/assignment/${assignmentId}`).then(({ data }) => {
        var _a, _b;
        return ({
            id: data.id,
            title: data.title,
            description: data.meta.description,
            qualifications: data.meta.qualifications,
            schedule: data.meta.schedule,
            benefits: data.meta.benefits,
            totalSpots: data.meta.number_of_available_spots,
            signUp: {
                type: data.meta.internal_assignment
                    ? SignUpTypes.Internal
                    : data.meta.signup_methods[0] || null,
                link: data.meta.signup_link,
                email: data.meta.signup_email,
                phone: data.meta.signup_phone,
            },
            employer: {
                name: ((_a = data === null || data === void 0 ? void 0 : data.meta) === null || _a === void 0 ? void 0 : _a.employer_name) || '',
                website: ((_b = data === null || data === void 0 ? void 0 : data.meta) === null || _b === void 0 ? void 0 : _b.employer_website) || '',
                contacts: [
                    {
                        name: '',
                        email: '',
                        phone: '',
                    },
                ],
            },
        });
    }),
});
